import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { SETTINGS_REDIRECTS } from './settingsTree';

// BL-177 Step 2j (E): the old personal-settings URLs, as <Route>s to drop inside CRMApp's <Routes>:
//   /settings/account -> /settings/profile, /my-notifications and /settings/notification-preferences -> Communications > Notifications,
//   /settings/my-signature -> Communications > Signature.
// A query string (a link from an email or push alert) is carried over. The Admin Center redirects (/settings/financials ->
// /admin/financials, ...) are unchanged and stay in CRMApp.
export function settingsRedirectRoutes(search = '') {
    return SETTINGS_REDIRECTS.map(({ from, to }) => (
        <Route key={from} path={from} element={<Navigate to={`${to}${search}`} replace />} />
    ));
}
